import { Container, Heading, SimpleGrid } from '@hover/blueprint';
import React from 'react';
import { PROS_RENDERINGS } from '../../../constants';
import { IProsRestorationInfo } from '../../../interfaces/IProsRestorationInfo';
import InfoBox from './InfoBox';

const Info: React.FC = () => (
  <Container
    w="100%"
    maxW="1248px"
    px={{ base: 500, tablet: '56px' }}
    centerContent
    mb={1000}
  >
    <Heading
      maxW="4xl"
      isLight
      as="h2"
      size={{ base: 500, tablet: 600, desktop: 700 }}
      marginBottom={{ base: 700, tablet: '80px', desktop: '80px' }}
      textAlign="center"
    >
      Unseen is unsold
    </Heading>
    <SimpleGrid
      columns={{ base: 1, tablet: 3 }}
      w="100%"
      spacing={{ base: 800, desktop: '80px' }}
    >
      {PROS_RENDERINGS.map((info: IProsRestorationInfo) => (
        <InfoBox
          key={info.id}
          icon={info.icon}
          body={info.body}
          header={info.header}
        />
      ))}
    </SimpleGrid>
  </Container>
);

export default Info;
